<script>
  import ShareableTreemap from "./ShareableTreemap.svelte";
  //   let show = false;

  import { toJpeg } from "html-to-image";
  let downloadableEl;
  let downloading = false;
  const download = function () {
    if (downloading) return;
    downloading = true;
    toJpeg(downloadableEl).then(function (dataUrl) {
      downloading = false;

      var link = document.createElement("a");
      link.download = "My Budget Preferences.jpeg";
      link.href = dataUrl;
      link.click();
    });
  };

  $: buttonText = downloading ? "Loading..." : "Share this";
</script>

<button on:click={download}>{buttonText}</button>
<ShareableTreemap bind:downloadable={downloadableEl} />

<style>
  button {
    padding: 0.35rem 0.45rem;
    background: var(--accent-color);
    color: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 1.35rem;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 1px;
  }

  @media screen and (max-width: 668px) {
    button {
      font-size: 1rem;
    }
  }
</style>
